import React, { Component } from 'react';

export default class SafeRetirementTextIndicator extends Component {

  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className="ui-card__heading half-margin-bottom">
        { !this.props.withoutHeader &&
          <h5>
            Safe Retirement Status
          </h5>
        }
        {
          this.props.name &&
          <p>{this.props.name}</p>
        }
        <div className="status-text bold">
          {this.props.text}
        </div>
      </div>
    );
  }
}
